const RELATIVE_POSITION = ['relative', 'sticky'];
const findFirstRelativeElement = (element) => {
    if (element === document.body || RELATIVE_POSITION.includes(getComputedStyle(element).position)) {
        return element;
    }
    const parentElement = element.parentElement;
    if (parentElement === null) {
        return element;
    }
    return findFirstRelativeElement(parentElement);
};
const getMetrics = (element) => {
    return element.getBoundingClientRect();
};
const getOffsetElement = (element, hostElement) => {
    const elementMetrics = getMetrics(element);
    const hostMetrics = getMetrics(hostElement);
    return { offsetTop: elementMetrics.top - hostMetrics.top, offsetLeft: elementMetrics.left - hostMetrics.left };
};

export { findFirstRelativeElement, getOffsetElement };
//# sourceMappingURL=metrics.js.map
